// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --bg: #0c111d;
  --card: #111827;
  --text: #e5e7eb;
  --muted: #9ca3af;
  --accent: #22d3ee;
  --border: #1f2937;
  --danger: #f87171;
  --good: #34d399;
  --warning: #f59e0b;
  --shadow: 0 20px 45px rgba(0, 0, 0, 0.45);
  color-scheme: dark;
}

* {
  box-sizing: border-box;
}

body {
  margin: 0;
  font-family: 'Inter', system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  background: radial-gradient(circle at 20% 20%, rgba(34, 211, 238, 0.07), transparent 25%),
    radial-gradient(circle at 80% 0%, rgba(139, 92, 246, 0.09), transparent 30%),
    var(--bg);
  color: var(--text);
  min-height: 100vh;
}

.layout {
  max-width: 1100px;
  margin: 0 auto;
  padding: 32px 24px 80px;
}

.hero {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  margin-bottom: 28px;
}

.hero h1 {
  margin: 4px 0 0;
  font-size: 32px;
  letter-spacing: -0.5px;
}

.tagline {
  color: var(--muted);
  margin: 0;
}

.card {
  background: linear-gradient(145deg, #0c1222, #0b152c);
  border: 1px solid var(--border);
  box-shadow: var(--shadow);
  border-radius: 18px;
  padding: 20px 22px;
  margin-bottom: 18px;
}

.section-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
}

.eyebrow {
  text-transform: uppercase;
  letter-spacing: 0.4px;
  color: var(--muted);
  font-size: 12px;
  margin: 0 0 4px;
}

.badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 6px 12px;
  border-radius: 999px;
  background: rgba(34, 211, 238, 0.12);
  color: var(--accent);
  border: 1px solid rgba(34, 211, 238, 0.35);
  font-weight: 700;
  letter-spacing: 0.2px;
}

.helper {
  color: var(--muted);
  margin: 0 0 12px;
  line-height: 1.5;
}

.form-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 14px;
}

.field {
  display: flex;
  flex-direction: column;
  gap: 6px;
  color: var(--muted);
  font-weight: 600;
}

input {
  background: #0f172a;
  border-radius: 12px;
  border: 1px solid var(--border);
  padding: 12px;
  color: var(--text);
  font-size: 15px;
  transition: border-color 150ms ease, box-shadow 150ms ease;
}

input:focus {
  outline: none;
  border-color: var(--accent);
  box-shadow: 0 0 0 3px rgba(34, 211, 238, 0.2);
}

.actions {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  align-items: center;
  margin-top: 10px;
}

button {
  background: linear-gradient(120deg, #22d3ee, #3b82f6);
  color: #0b1021;
  border: none;
  border-radius: 12px;
  padding: 12px 16px;
  font-weight: 700;
  cursor: pointer;
  transition: transform 120ms ease, box-shadow 120ms ease;
  box-shadow: 0 10px 30px rgba(59, 130, 246, 0.35);
}

.ghost {
  background: rgba(255, 255, 255, 0.08);
  color: var(--text);
  border: 1px solid var(--border);
  box-shadow: none;
  padding: 10px 14px;
}

button:hover {
  transform: translateY(-1px);
}

button:disabled {
  opacity: 0.7;
  cursor: not-allowed;
  box-shadow: none;
}

.search {
  flex: 1 1;
  min-width: 220px;
}

.error {
  color: var(--danger);
  margin: 12px 0 0;
  font-weight: 600;
}

.table-wrapper {
  overflow-x: auto;
}

table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
}

th,
td {
  text-align: left;
  padding: 10px;
  border-bottom: 1px solid var(--border);
}

th {
  color: var(--muted);
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

td {
  color: var(--text);
}

.pill {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 10px;
  border-radius: 999px;
  border: 1px solid var(--border);
  text-transform: capitalize;
}

.pill-active,
.pill-positive {
  background: rgba(52, 211, 153, 0.15);
  color: var(--good);
  border-color: rgba(52, 211, 153, 0.35);
}

.pill-prospect,
.pill-at-risk {
  background: rgba(245, 158, 11, 0.18);
  color: var(--warning);
  border-color: rgba(245, 158, 11, 0.3);
}

.pill-risk {
  background: rgba(248, 113, 113, 0.18);
  color: var(--danger);
  border-color: rgba(248, 113, 113, 0.3);
}

.stat-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
  gap: 10px;
  margin: 10px 0 16px;
}

.stat {
  background: rgba(255, 255, 255, 0.02);
  border: 1px solid var(--border);
  border-radius: 12px;
  padding: 12px 14px;
}

.stat strong {
  font-size: 20px;
}

.sync-meta {
  display: flex;
  align-items: center;
}

.deals-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 14px;
}

.deal-card {
  background: rgba(255, 255, 255, 0.02);
  border: 1px solid var(--border);
  border-radius: 14px;
  padding: 14px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.deal-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.deal-top h3 {
  margin: 0;
}

.deal-meta {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
  gap: 8px 12px;
  margin: 0;
}

.deal-meta dt {
  color: var(--muted);
  font-size: 12px;
  margin: 0 0 2px;
}

.deal-meta dd {
  margin: 0;
  font-weight: 600;
}

.empty {
  text-align: center;
  color: var(--muted);
  padding: 20px 10px;
}

@media (max-width: 720px) {
  .layout {
    padding: 20px 16px 60px;
  }

  .hero {
    flex-direction: column;
    align-items: flex-start;
  }

  button {
    width: 100%;
    text-align: center;
  }

  .actions {
    align-items: stretch;
  }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,yCAAyC;EACzC,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,0FAA0F;EAC1F;;aAEW;EACX,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,qDAAqD;EACrD,+BAA+B;EAC/B,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;EACnB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,oBAAoB;EACpB,oCAAoC;EACpC,oBAAoB;EACpB,0CAA0C;EAC1C,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,+BAA+B;EAC/B,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,0DAA0D;AAC5D;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,qDAAqD;EACrD,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,uDAAuD;EACvD,gDAAgD;AAClD;;AAEA;EACE,qCAAqC;EACrC,kBAAkB;EAClB,+BAA+B;EAC/B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA;;EAEE,gBAAgB;EAChB,aAAa;EACb,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oBAAoB;EACpB,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;;EAEE,oCAAoC;EACpC,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;;EAEE,oCAAoC;EACpC,qBAAqB;EACrB,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;EACrC,oBAAoB;EACpB,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,+BAA+B;EAC/B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,qCAAqC;EACrC,+BAA+B;EAC/B,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,aAAa;EACb,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,oBAAoB;EACtB;AACF","sourcesContent":[":root {\n  --bg: #0c111d;\n  --card: #111827;\n  --text: #e5e7eb;\n  --muted: #9ca3af;\n  --accent: #22d3ee;\n  --border: #1f2937;\n  --danger: #f87171;\n  --good: #34d399;\n  --warning: #f59e0b;\n  --shadow: 0 20px 45px rgba(0, 0, 0, 0.45);\n  color-scheme: dark;\n}\n\n* {\n  box-sizing: border-box;\n}\n\nbody {\n  margin: 0;\n  font-family: 'Inter', system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;\n  background: radial-gradient(circle at 20% 20%, rgba(34, 211, 238, 0.07), transparent 25%),\n    radial-gradient(circle at 80% 0%, rgba(139, 92, 246, 0.09), transparent 30%),\n    var(--bg);\n  color: var(--text);\n  min-height: 100vh;\n}\n\n.layout {\n  max-width: 1100px;\n  margin: 0 auto;\n  padding: 32px 24px 80px;\n}\n\n.hero {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 14px;\n  margin-bottom: 28px;\n}\n\n.hero h1 {\n  margin: 4px 0 0;\n  font-size: 32px;\n  letter-spacing: -0.5px;\n}\n\n.tagline {\n  color: var(--muted);\n  margin: 0;\n}\n\n.card {\n  background: linear-gradient(145deg, #0c1222, #0b152c);\n  border: 1px solid var(--border);\n  box-shadow: var(--shadow);\n  border-radius: 18px;\n  padding: 20px 22px;\n  margin-bottom: 18px;\n}\n\n.section-heading {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 12px;\n}\n\n.eyebrow {\n  text-transform: uppercase;\n  letter-spacing: 0.4px;\n  color: var(--muted);\n  font-size: 12px;\n  margin: 0 0 4px;\n}\n\n.badge {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 6px 12px;\n  border-radius: 999px;\n  background: rgba(34, 211, 238, 0.12);\n  color: var(--accent);\n  border: 1px solid rgba(34, 211, 238, 0.35);\n  font-weight: 700;\n  letter-spacing: 0.2px;\n}\n\n.helper {\n  color: var(--muted);\n  margin: 0 0 12px;\n  line-height: 1.5;\n}\n\n.form-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\n  gap: 14px;\n}\n\n.field {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  color: var(--muted);\n  font-weight: 600;\n}\n\ninput {\n  background: #0f172a;\n  border-radius: 12px;\n  border: 1px solid var(--border);\n  padding: 12px;\n  color: var(--text);\n  font-size: 15px;\n  transition: border-color 150ms ease, box-shadow 150ms ease;\n}\n\ninput:focus {\n  outline: none;\n  border-color: var(--accent);\n  box-shadow: 0 0 0 3px rgba(34, 211, 238, 0.2);\n}\n\n.actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  align-items: center;\n  margin-top: 10px;\n}\n\nbutton {\n  background: linear-gradient(120deg, #22d3ee, #3b82f6);\n  color: #0b1021;\n  border: none;\n  border-radius: 12px;\n  padding: 12px 16px;\n  font-weight: 700;\n  cursor: pointer;\n  transition: transform 120ms ease, box-shadow 120ms ease;\n  box-shadow: 0 10px 30px rgba(59, 130, 246, 0.35);\n}\n\n.ghost {\n  background: rgba(255, 255, 255, 0.08);\n  color: var(--text);\n  border: 1px solid var(--border);\n  box-shadow: none;\n  padding: 10px 14px;\n}\n\nbutton:hover {\n  transform: translateY(-1px);\n}\n\nbutton:disabled {\n  opacity: 0.7;\n  cursor: not-allowed;\n  box-shadow: none;\n}\n\n.search {\n  flex: 1;\n  min-width: 220px;\n}\n\n.error {\n  color: var(--danger);\n  margin: 12px 0 0;\n  font-weight: 600;\n}\n\n.table-wrapper {\n  overflow-x: auto;\n}\n\ntable {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 14px;\n}\n\nth,\ntd {\n  text-align: left;\n  padding: 10px;\n  border-bottom: 1px solid var(--border);\n}\n\nth {\n  color: var(--muted);\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\ntd {\n  color: var(--text);\n}\n\n.pill {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 10px;\n  border-radius: 999px;\n  border: 1px solid var(--border);\n  text-transform: capitalize;\n}\n\n.pill-active,\n.pill-positive {\n  background: rgba(52, 211, 153, 0.15);\n  color: var(--good);\n  border-color: rgba(52, 211, 153, 0.35);\n}\n\n.pill-prospect,\n.pill-at-risk {\n  background: rgba(245, 158, 11, 0.18);\n  color: var(--warning);\n  border-color: rgba(245, 158, 11, 0.3);\n}\n\n.pill-risk {\n  background: rgba(248, 113, 113, 0.18);\n  color: var(--danger);\n  border-color: rgba(248, 113, 113, 0.3);\n}\n\n.stat-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));\n  gap: 10px;\n  margin: 10px 0 16px;\n}\n\n.stat {\n  background: rgba(255, 255, 255, 0.02);\n  border: 1px solid var(--border);\n  border-radius: 12px;\n  padding: 12px 14px;\n}\n\n.stat strong {\n  font-size: 20px;\n}\n\n.sync-meta {\n  display: flex;\n  align-items: center;\n}\n\n.deals-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));\n  gap: 14px;\n}\n\n.deal-card {\n  background: rgba(255, 255, 255, 0.02);\n  border: 1px solid var(--border);\n  border-radius: 14px;\n  padding: 14px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.deal-top {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.deal-top h3 {\n  margin: 0;\n}\n\n.deal-meta {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));\n  gap: 8px 12px;\n  margin: 0;\n}\n\n.deal-meta dt {\n  color: var(--muted);\n  font-size: 12px;\n  margin: 0 0 2px;\n}\n\n.deal-meta dd {\n  margin: 0;\n  font-weight: 600;\n}\n\n.empty {\n  text-align: center;\n  color: var(--muted);\n  padding: 20px 10px;\n}\n\n@media (max-width: 720px) {\n  .layout {\n    padding: 20px 16px 60px;\n  }\n\n  .hero {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  button {\n    width: 100%;\n    text-align: center;\n  }\n\n  .actions {\n    align-items: stretch;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
